import { GetItContext } from "../../base/provider/GetItContext";
import { useStore } from "../../hooks/useStore";
import { NodesUtil } from "../NodesUtil";
import { Video } from "../Video/VideoNode";
import { useSignal } from "@preact/signals-react";
import { Button, Empty, Spin } from "antd";
import cls from "classnames";
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { ChatOnboardingStore } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboarding";
import React, { useContext, useEffect } from "react";
import { Audio } from "./Audio/Auido";
import { FallBackText } from "./FallBackText/FallBackText";
import { L1 } from "./L1/L1";
import { Map } from "./Map/Map";
import { ProfileCard } from "./ProfileCard/ProfileCard";
import style from "./ViewBuilderCpWrapper.module.scss";
import { ShareLocation } from "./ShareLocation/ShareLocation";
import { GeneratedImage } from "./GeneratedImage/GeneratedImage";
import { Text } from "./Text/Text";
import { YoutubeSearchResults } from "./YoutubeSearchResults/YoutubeSearchResults";
import { YoutubeVideo } from "./YoutubeVideo/YoutubeVideo";
import { C1 } from "./C1/C1";
import { C2 } from "./C2/C2";
import { C3 } from "./C3/C3";
import { C4 } from "./C4/C4";
export var CpCofig = {
  c1: C1,
  c2: C2,
  c3: C3,
  c4: C4,
  l1: L1,
  audio: Audio,
  map1: Map,
  map2: Map,
  t1: Text,
  t2: Text,
  // todo: 需要修改字段匹配
  textTitle: Text,
  profileCard: ProfileCard,
  generatedImage: GeneratedImage,
  youtube: Video,
  youtubeVideo: YoutubeVideo,
  youtubeSearchResults: YoutubeSearchResults,
  shareLocation: ShareLocation
};
export var ViewBuilderCpWrapper = function ViewBuilderCpWrapper(props) {
  var _props$viewBuilderDat, _props$viewBuilderDat2, _props$viewBuilderDat3, _props$initialReportS, _props$initialReportS2, _props$initialReportS3, _props$initialReportS4, _props$resizeEventPar3, _props$resizeEventPar4, _domList$2, _domList$0$screenInfo, _domList$3, _props$checkNodeArr, _props$readonlyStyle;
  var getIt = useContext(GetItContext);
  var chatOnboardingStore = getIt(ChatOnboardingStore);
  var chatOnboardingStoreState = useStore(chatOnboardingStore).value;
  var domList = ((_props$viewBuilderDat = props.viewBuilderData) === null || _props$viewBuilderDat === void 0 ? void 0 : _props$viewBuilderDat.domList) || [];
  var originalText = ((_props$viewBuilderDat2 = props.viewBuilderData) === null || _props$viewBuilderDat2 === void 0 ? void 0 : _props$viewBuilderDat2.originalText) || "";
  var loadingHtml = ((_props$viewBuilderDat3 = props.viewBuilderData) === null || _props$viewBuilderDat3 === void 0 ? void 0 : _props$viewBuilderDat3.loadingHtml) || false;
  var warpperStyle = useSignal({
    width: typeof ((_props$initialReportS = props.initialReportSize) === null || _props$initialReportS === void 0 ? void 0 : _props$initialReportS.width) === "string" ? (_props$initialReportS2 = props.initialReportSize) === null || _props$initialReportS2 === void 0 ? void 0 : _props$initialReportS2.width : ((_props$initialReportS3 = props.initialReportSize) === null || _props$initialReportS3 === void 0 ? void 0 : _props$initialReportS3.width) - 20,
    height: (_props$initialReportS4 = props.initialReportSize) === null || _props$initialReportS4 === void 0 ? void 0 : _props$initialReportS4.height
  });
  useEffect(function () {
    var _domList$;
    // 重新计算尺寸
    if (props.isResized) {
      var _props$initialReportS5, _props$initialReportS6, _props$resizeEventPar, _props$resizeEventPar2;
      warpperStyle.value = {
        width: typeof ((_props$initialReportS5 = props.initialReportSize) === null || _props$initialReportS5 === void 0 ? void 0 : _props$initialReportS5.width) === "string" ? (_props$initialReportS6 = props.initialReportSize) === null || _props$initialReportS6 === void 0 ? void 0 : _props$initialReportS6.width : (((_props$resizeEventPar = props.resizeEventParams) === null || _props$resizeEventPar === void 0 ? void 0 : _props$resizeEventPar.width) || props.initialReportSize.width) - 20,
        height: (_props$resizeEventPar2 = props.resizeEventParams) !== null && _props$resizeEventPar2 !== void 0 && _props$resizeEventPar2.height ? props.resizeEventParams.height - 190 : props.initialReportSize.height
      };
      return;
    }
    if (loadingHtml || !isBlank((_domList$ = domList[0]) === null || _domList$ === void 0 ? void 0 : _domList$.screenInfo)) {
      warpperStyle.value = {
        width: "unset",
        height: "unset"
      };
    }
  }, [(_props$resizeEventPar3 = props.resizeEventParams) === null || _props$resizeEventPar3 === void 0 ? void 0 : _props$resizeEventPar3.width, (_props$resizeEventPar4 = props.resizeEventParams) === null || _props$resizeEventPar4 === void 0 ? void 0 : _props$resizeEventPar4.height, loadingHtml, domList === null || domList === void 0 || (_domList$2 = domList[0]) === null || _domList$2 === void 0 || (_domList$2 = _domList$2.screenInfo) === null || _domList$2 === void 0 ? void 0 : _domList$2.length]);
  var list = (_domList$0$screenInfo = (_domList$3 = domList[0]) === null || _domList$3 === void 0 ? void 0 : _domList$3.screenInfo) !== null && _domList$0$screenInfo !== void 0 ? _domList$0$screenInfo : [];
  return /*#__PURE__*/React.createElement("div", {
    className: cls(style.viewBuilder, props.isInCanvas ? style.viewBuilderMinHgt : "")
  }, props.showBuilderUI && /*#__PURE__*/React.createElement(React.Fragment, null, loadingHtml && /*#__PURE__*/React.createElement("div", {
    className: style.spinBox
  }, /*#__PURE__*/React.createElement(Spin, {
    spinning: loadingHtml
  })), /*#__PURE__*/React.createElement("div", {
    className: cls(style.viewBuilderWrapper, ((props === null || props === void 0 ? void 0 : props.isLongPress) || (props === null || props === void 0 || (_props$checkNodeArr = props.checkNodeArr) === null || _props$checkNodeArr === void 0 ? void 0 : _props$checkNodeArr.includes(props.id))) && "nopan ".concat(NodesUtil.constants.NO_WHEEL)),
    style: Object.assign({}, warpperStyle.value, {
      maxHeight: props.readOnly ? "unset" : "670px"
    })
  }, isBlank(list) && !loadingHtml && /*#__PURE__*/React.createElement("div", {
    className: style.empty
  }, !isBlank(originalText) ? /*#__PURE__*/React.createElement(FallBackText, {
    readonlyStyle: props.readonlyStyle
  }, originalText) : /*#__PURE__*/React.createElement(Empty, {
    image: Empty.PRESENTED_IMAGE_SIMPLE
  })), list.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CpCofig[item.type] || C1, {
      key: index,
      item: item,
      isInCanvas: props.isInCanvas,
      readonlyStyle: props.readonlyStyle
    });
  }))), (props.isInCanvas || (chatOnboardingStoreState === null || chatOnboardingStoreState === void 0 ? void 0 : chatOnboardingStoreState.isOpenChat)) && /*#__PURE__*/React.createElement("div", {
    className: style.bottomButton
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    shape: "round",
    style: (_props$readonlyStyle = props.readonlyStyle) !== null && _props$readonlyStyle !== void 0 ? _props$readonlyStyle : {},
    disabled: props.showBuilderUI && loadingHtml,
    onClick: function onClick() {
      return props.clickViewBuilderBtn();
    }
  }, props.showBuilderUI ? "View text" : "Build UI")));
};